module.exports = {
  active: "active",
  history: "history",
  any: "any",
  both: "both",
};
